export const CHART_STROKE_COLOR = '#EFF2F5';
export const FILLING_DATA_FILL_STROKE_COLOR = 'rgb(236, 242, 251)';
export const TEXT_COLOR_FOR_CHART_SVG = '#2C476C';
